import { makeStyles } from "tss-react/mui";
import { Checkbox, FormControlLabel } from "@mui/material";

export function MiCheckbox({
  label = "",
  name = "",
  value = false,
  handleChange,
  labelPlacement = "end",
  disableRipple = false,
  disabled = false,
  icon = undefined,
  checkedIcon = undefined,
  color = "primary",
  style = {},
  size = "medium",
  labelStyle = {},
}) {
  const { classes } = useStyles();

  return (
    <FormControlLabel
      className={classes.checkbox}
      data-testid={`mi-checkbox-${name}`}
      sx={{ ...labelStyle }}
      control={
        <Checkbox
          checked={value}
          onChange={handleChange}
          disabled={disabled}
          disableRipple={disableRipple}
          icon={icon}
          color={color}
          checkedIcon={checkedIcon}
          style={style}
          size={size}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
}

const useStyles = makeStyles()(() => ({
  checkbox: { margin: 0 },
}));
